export default __webpack_public_path__ + "static/Privacy_verklaring-33772a482feacfb43f1232fd6da80c9d.pdf";